<div class="certificates-container">
  <div class="header">
    <span>Manage all your SSL certificates to keep your websites and services secure. On this page, you can request,
      monitor, revoke, and renew your certificates.</span>
    <div class="actions" *ngIf="!isKeyRotation">
      <div class="search-input-container">
        <i class="fa-solid fa-magnifying-glass" style="opacity: 0.9; color: #289DD2;"></i>
        <input type="text" (input)="onSearchChange()" [(ngModel)]="searchQuery" placeholder="Search certificates..."
          class="search-input" />
        <i *ngIf="searchQuery" class="fa-solid fa-xmark clear-search"
          style="opacity: 0.8; cursor: pointer; color: #289DD2; margin-left: 5px;"
          (click)="searchQuery = ''; onSearchChange()"></i>
      </div>
      <button class="add-button" (click)="navigateToChatComponent()">
        <i class="fa-solid fa-plus" style="margin-right: 8px;"></i>Add New
      </button>
    </div>
  </div>
  <div class="table-container">
    <table class="certificates-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-certificate th-icon"></i>
              <span>Common Name</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-tags th-icon"></i>
              <span>Alternative Names</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-building-columns th-icon"></i>
              <span>Certificate Authority</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-circle-info th-icon"></i>
              <span>Status</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-regular fa-calendar-xmark th-icon"></i>
              <span>Expiration</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <!-- <i class="fa-solid fa-gears th-icon"></i> -->
              <i class="fa-solid fa-download th-icon"></i>
              <span>Download certificate</span>
            </div>
          </th>

        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="certificates.length > 0; else noCertificates">
          <tr *ngFor="let certificate of filteredCertificates">
            <td style="font-weight: 500;">{{ certificate?.certificate?.subject?.CN ?? certificate?.domain }}</td>
            <td>{{ certificate?.certificate?.subjectaltname?.replaceAll('DNS:','') }}</td>
            <td>{{ certificate?.certificate?.issuer?.O }}</td>
            <td>{{ getStatus(certificate) }}</td>
            <td style="opacity: 0.9; font-size: 14px;">{{ certificate?.certificate?.valid_to | date: 'MMM dd, yyyy' }}
            </td>
            <td class="h-[55px]">
              <button
                class="px-4 py-[5px] rounded-full bg-transparent text-[#289DD2] hover:font-bold hover:border-2 hover:px-3 hover:py-[3px]  transition duration-300 border border-[#289DD2] mx-1"
                style="font-size: 14px; cursor: pointer; letter-spacing: 0.3px;"
                (click)="confirmRotateKeys(certificate)">
                Rotate Keys
              </button>
            </td>
            <td class="h-[55px]">
              <!-- <span>{{certificate.certFiles}}</span> -->
              <div *ngFor="let cer of certificate.certFiles">
                <button
                  class="px-4 py-[5px] mt-1 rounded-full bg-transparent text-[#289DD2] hover:font-bold hover:border-2 hover:px-3 hover:py-[3px] transition duration-300 border border-[#289DD2] mx-1"
                  style="font-size: 14px; cursor: pointer; letter-spacing: 0.3px;" (click)="downloadCertificate(cer)">
                  Download {{cer.name??''}}
                </button>
              </div>
            </td>


          </tr>
        </ng-container>
        <ng-template #noCertificates>
          <tr>
            <td colspan="7" class="no-certificates-message">
              {{ noCertificatesMessage }}
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="rotateKeyCert != null" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-black p-6 rounded-lg shadow-lg w-70 border border-gray-700">
    <h2 class="text-white text-lg font-semibold mb-4">Key Rotation</h2>
    <div *ngIf="errMsg" class="text-red-500 mt-1 text-sm">

    </div>

    <div class="mb-4 text-white">
      Are you sure you want to rotate the keys for certificate with Common Name: <span
        class="font-bold">{{rotateKeyCert?.domain}}</span>?
    </div>

    <div class="flex justify-end space-x-2">
      <button type="button" class="bg-transparent border border-[#289DD2] text-[#289DD2] px-4 py-2 rounded opacity-70"
        (click)="closeRotateKeyModal()">
        Cancel
      </button>
      <button type="submit" (click)="rotateKeys(rotateKeyCert?.domain, rotateKeyCert?._id)"
        class="bg-[#289DD2] text-white px-4 py-2 rounded hover:bg-[#289DD2]">
        Proceed
      </button>
    </div>

  </div>
</div>